import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import {
  apiFinancialCalcReversal,
  FinancialCalcReversalReq,
  FinancialCalcReversalRes,
  FinancialCalcReversalResult,
} from '../../api/selfApi'

export interface FinancialCalcReversalState {
  result: FinancialCalcReversalResult | undefined
  responseCode: number
  fetchState: 'initialize' | 'pending' | 'fulfilled' | 'rejected'
}

export const initialState: FinancialCalcReversalState = {
  result: undefined,
  responseCode: 0,
  fetchState: 'initialize',
}

// TODO ApiのstatusCodeによるエラー処理など
export const fetchFinancialCalcReversal = createAsyncThunk<
  FinancialCalcReversalRes,
  FinancialCalcReversalReq
>('financialCalcReversal/fetchApi', async (arg) => {
  const response = await apiFinancialCalcReversal(arg)
  return response.payload
})

export const financialCalcReversal = createSlice({
  name: 'financialCalcReversal',
  initialState,
  reducers: {
    reset: (state) => {
      return initialState
    },
    resetResponseCode: (state) => {
      state.responseCode = 0
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchFinancialCalcReversal.pending, (state, action) => {
      state.fetchState = 'pending'
    })
    builder.addCase(fetchFinancialCalcReversal.fulfilled, (state, action) => {
      state.fetchState = 'fulfilled'
      state.responseCode = action.payload.statusCode
      state.result = action.payload.result
    })
    builder.addCase(fetchFinancialCalcReversal.rejected, (state, action) => {
      state.fetchState = 'rejected'
      state.result = undefined
      state.responseCode = 20
    })
  },
})

export const { reset, resetResponseCode } = financialCalcReversal.actions
